<template>
  <div>
    <div class="member-main-tab">
      <ul class="main-tab">
        <li class="active">所有课程({{youxiaoCount}})</li>
        <!-- <li class="active">已学课程({{yiyueCount}})</li> -->
      </ul>
    </div>

    <div class="member-main-body">
      <div v-for="(v, k) in list" :key="k">
        <div class="course-fa">
          <div class="course-title">
          {{v.title}}
          <span v-if="v.title=='省考公务员' && area"> - {{area}}</span>
          </div>
          <div class="times-box">
            <div class="course-matter" v-if="v.matter && v.matter.apply"><span>报名时间：</span>{{v.matter.apply_stime}}</div>
            <div class="course-matter" v-if="v.matter && v.matter.examcard"><span>准考证打印时间：</span>{{v.matter.examcard_time}}</div>
            <div class="course-matter" v-if="v.matter && v.matter.exam"><span>考试时间：</span>{{v.matter.exam_time}}</div>
          </div>
        </div>
        <ul class="course-list">
          <!-- <li v-for="(item, index) in v.child" :key="index">
            <div class="course-name">
              <router-link
                :to="{ name: 'Study', params: { cid: item.cid } }"
                title="开始学习"
              >
            {{item.title}}
            </router-link>
            </div>
            <div class="course-btn">
              <router-link
                :to="{ name: 'Study', params: { cid: item.cid } }"
                title="开始学习"
              >
                <el-button type="primary">开始学习</el-button>
              </router-link>
            </div>
          </li> -->
          <div class="right-box" v-for="(item, index) in v.child" :key="index">
            <div class="box1">
              <div class="box1-left" v-if="item.banner">
                <img :src="img_url+item.banner" alt="">
              </div>
              <div class="box1-left" v-else>
                <img src="https://shijizhongshi-image.obs.cn-north-4.myhuaweicloud.com/2023/2/9/427735940925814939/%E6%8A%A4%E8%88%AA.png"/>
              </div>
              <div class="box1-right">
                <div class="box1-right-tiltle">
                  <router-link
                      :to="{ name: 'Study', params: { cid: item.cid } }"
                      title="开始学习"
                    >
                  {{item.title}}
                  </router-link>
                  <!-- <div>{{item.title}}</div> -->
                </div>
                <div class="watch-bar">
                  <!-- <p>已观看</p> -->
                  <div></div>
                </div>
              </div>
            </div>
            <div class="box2"></div>
            <div class="box3" v-if="item.last_name">
              <p>上次学到</p>
              <p :title="item.last_name"> {{item.last_name}} </p>
            </div>
            <div class="box3" v-else>
              <p>暂未学习</p>
            </div>
            <div class="box4"></div>
            <div class="box5">
              <router-link
                :to="{ name: 'Study', params: { cid: item.cid } }"
              >
                <el-button type="primary" v-if="item.last_name">继续学习</el-button>
                <el-button type="primary" v-else>开始学习</el-button>
              </router-link>
            </div>
          </div>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from "vuex";
import { getCourseList } from "../../api/api";
export default {
  computed: {
    ...mapState(["img_url"])
  },
  data() {
    return {
      youxiaoCount: 0,
      area: '',
      yiyueCount: 1,
      list: []
    };
  },
  created() {
    this.getCourseListx();
  },
  methods: {
    getCourseListx(){
      getCourseList({})
        .then(res => {
          if (res.code == 1) {
            let listx = res.data.course_list;
            this.list = listx;
            this.youxiaoCount = res.data.count;
            this.area = res.data.area
          }else if(res.code == -2){
            // this.$Message.info('登陆超时，请重新登录');
            this.$router.push('/login')
          }
        })
        .catch(err => {

        });
    }
  },
};
</script>


<style>
.member-main-tab {
    width: 100%;
    height: 60px;
    background: #fff;
    border-radius: 6px;
    margin-bottom: 20px;
    box-shadow: 0 0 5px rgba(0, 0, 0, .1);
    display: flex
  }

  .member-main-tab .main-tab {
    flex: 1;
    padding: 10px 20px;
    display: flex
  }

  .member-main-tab .main-tab li {
    position: relative;
    height: 40px;
    line-height: 40px;
    cursor: pointer;
    color: #666;
    padding: 0 10px;
    margin-right: 40px
  }

  .member-main-tab .main-tab li:hover {
    color: #333
  }

  .member-main-tab .main-tab li.active {
    font-weight: 700;
    color: #333
  }

  .member-main-tab .main-tab li.active:after {
    position: absolute;
    content: " ";
    color: #fff;
    background: linear-gradient(90deg, #27a3ff, #2380fb);
    width: 20px;
    height: 4px;
    border-radius: 10px;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%)
  }

  .member-main-body {
    position: relative;
    width: 100%;
    background: #fff;
    border-radius: 6px;
    min-height: 560px;
    box-shadow: 0 0 5px rgba(0, 0, 0, .1)
  }

  .member-main-body .main-header {
    width: 100%;
    background: #f5f5f5;
    height: 60px;
    padding: 0 30px;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px
  }

  .member-main-body .no-data {
    padding-top: 100px;
    text-align: center
  }

  .member-main-body .no-data img {
    margin: 0 auto
  }

  .member-main-body .no-data p {
    font-size: 16px;
    color: #666
  }

  .member-main-body .main-table {
    position: relative;
    width: 100%;
    padding: 0 30px
  }

  .member-main-body .main-table.scroll-top {
    margin-top: -60px
  }

  .member-main-body .main-table table {
    width: 100%
  }

  .member-main-body .main-table table thead th {
    height: 60px;
    color: #999
  }

  .member-main-body .main-table table td,
  .member-main-body .main-table table th {
    text-align: left
  }

  .member-main-body .main-table table td.center,
  .member-main-body .main-table table th.center {
    text-align: center
  }

  .member-main-body .main-table table td.right,
  .member-main-body .main-table table th.right {
    text-align: right
  }

  .member-main-body .main-table table td {
    padding: 12px 0;
    border-bottom: 1px dashed #ccc;
    line-height: 20px;
    color: #666
  }

  .member-main-body .main-table table td .ellipsis {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden
  }

  .course-search {
    margin: 14px 30px 0 0
  }

  .course-search .ivu-input {
    background: #f2f2f2;
    border-radius: 20px;
    padding-left: 12px
  }

  .course-list {
    padding: 20px 30px
  }

  .course-list li {
    border-bottom: 1px dashed #ccc;
    display: flex;
    align-items: center;
    padding: 10px 0
  }

  .course-list li .course-name {
    flex: 1;
    font-size: 16px
  }

  .course-list li .course-btn {
    width: 100px
  }

  .course-fa{
    padding: 20px 20px 0 20px;
  }
  .course-fa .course-title{
    font-size: 18px;
    font-weight: bold;
  }
  .course-fa .times-box{
    display: flex;
  }
  .course-fa .course-matter{
    font-size:16px;
    margin-left:20px;
    color:red;
    margin-top:3px;
  }
  .course-fa .course-matter span{
    color:#000;
  }


  .right-box{
      width: 870px;
      height: 140px;
      border: 1px solid #ddd;
      margin: 0 auto;
      border-radius: 4px;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
  }
  .box1 {
      width: 55%;
      height: 140px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
  }

  .box1-left {
      height: 112px;
      background-color: #f5f7fa;
      margin-left: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 10px;
      overflow: hidden;
  }

  .box1-left-name {
      width: 90%;
      text-align: center;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
      display: -webkit-box;
      overflow: hidden;
      color: #b4bfce;
      font-weight: 700;
      font-size: 18px
  }

  .box1 .box1-left > img {
      width: auto;
      height: 100%
  }

  .box1-right {
      width: 60%;
      height: 100px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding-left: 10px
  }

  .box1-right-tiltle-courename {
      height: 25px;
      line-height: 25px
  }

  .box1-right-tiltle a {
      font-weight: 700;
      font-size: 18px;
      color: #000;
  }

  .box1-right > div:nth-child(2) {
      display: flex;
      color: #bdbdbd;
      font-size: 12px
  }

  .box1-right > div:nth-child(2) p:nth-child(2) {
      padding-left: 5px
  }

  .box1-right > div:nth-child(2) p:nth-child(3) {
      padding-left: 50px
  }

  .box2, .box4 {
      margin: 0 8px;
      width: 1px;
      height: 50px;
      background-color: #ddd
  }

  .box3 {
      width: 220px;
      height: 100px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 16px
  }

  .box3 p:nth-child(2) {
      color: #409EFF;
      text-align: center;
      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical
  }
  .box5 {
      width: 130px;
      height: 100px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center
  }

  .box5 div:first-child {
      width: 90px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      color: #fff;
      background-color: #409EFF;
      border-radius: 4px;
      font-size: 16px;
      cursor: pointer
  }
</style>



// WEBPACK FOOTER //
// src/pages/member/course.vue